<block-ui>
  <p-toast></p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
  <router-outlet></router-outlet>
</block-ui>
